import {BaseDto} from 'common';

export class ImportCsvResponseDto extends BaseDto {
    public importedPatients: number;
    // changed: errorNotes is now an array of strings
    public errorNotes: string[] = [];

    public deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
